var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasPrice && _vm.priceInfo.PriceWithoutTax !== null)?_c('div',{staticClass:"h3 configurator-additional-info"},[_vm._v("\n\tOplage: "),_c('strong',[_vm._v(_vm._s(_vm.getOrderLine.amount))])]):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e66fdc24","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/element/price-amount.vue
// module id = null
// module chunks = 